import React from "react";
import styled from "styled-components";
import Loading from "common/Loading";
import { getInformation, LOAD_INTERVAL, RETURN_VIEW } from "./utils";
import useDashboardData from "./useDashboardData";

const Wrapper = styled.div`
  width: 100%;

  .rowInfo {
    width: 100%;
    display: flex;
    margin-top: 4px;

    &:hover {
      cursor: pointer;
    }
  }

  .name {
    color: #6b7280;
    font-size: 11px;
    width: 120px;
  }

  .value {
    font-family: "AllianceNo2-SemiBold", sans-serif;
    color: var(--text-primary);
    font-size: 13px;
  }
`;

const WrapperLoader = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 135px;
  color: var(--text-primary);
`;

const Information = ({ name, value, link }) => {
  return (
    <div
      key={name}
      className="rowInfo"
      onClick={() =>
        globalNavigate(link, { returnView: RETURN_VIEW })
      }
    >
      <div className="name">{name}</div>
      <div className="value">{value}</div>
    </div>
  );
};

// Each command answers for the BQN selected alone, so its response carries
// one value and not one per BQN of the cluster, and none of them is known
// until the first answer of the batch.
const NO_INFORMATION = {
  hardwareId: "",
  systemName: "",
  version: "",
  startTime: "",
  license: [],
};

function SystemInformation({ systemTime }) {
  // The card has a cadence of its own: it draws no range of the dashboard,
  // so nothing else asks for its data again.
  const { data: sysInfo, isLoading } = useDashboardData({
    retrieve: ({ mode, bqnId }) => getInformation(mode, bqnId),
    onError: "Error fetching dashboard data:",
    interval: LOAD_INTERVAL,
  });

  const { hardwareId, systemName, version, startTime, license } =
    sysInfo || NO_INFORMATION;
  const isReadyLicense = license !== undefined && license.length > 0;

  if (isLoading) {
    return (
      <WrapperLoader>
        <Loading />
      </WrapperLoader>
    );
  }

  return (
    <Wrapper>
      <Information
        name="System Name"
        value={systemName}
        link="viewGeneralSettingsConfig"
      />
      <Information
        name="BQN Release"
        value={version}
        link="viewSoftware"
      />
      <Information
        name="Hardware ID"
        value={hardwareId}
        link="viewStatusSystemInfo"
      />
      <Information
        name="License Limit"
        value={isReadyLicense ? license[0] : "n/a"}
        link="viewLicense"
      />
      <Information
        name="License Expiration"
        value={isReadyLicense ? license[1] : "n/a"}
        link="viewLicense"
      />
      <Information name="Start Time" value={startTime} link="viewLogsSystem" />
      <Information
        name="System Time"
        value={systemTime ?? ""}
        link="viewSysDate"
      />
    </Wrapper>
  );
}

export default React.memo(SystemInformation);
